/** Sendbird user ID for the platform moderation account on 1:1 mentor/mentee chats. */
export const SYSTEM_MODERATOR_USER_ID = '627668';

export const GROUP_CHAT_CUSTOM_TYPE = 'group';
